export const DATA_TEST_IDS = {
  imageSlider: 'layouts_auth-layout_slider',
};

export default DATA_TEST_IDS;
